import { Star, SmilePlus, HeartHandshake } from "lucide-react";
import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";

const highlights = [
  {
    icon: Star,
    title: "5.0 Google Rating",
    text: "A strong reflection of trust, outcomes, and patient-centric communication.",
  },
  {
    icon: SmilePlus,
    title: "Smile Transformation Focus",
    text: "From implants to aesthetics, each plan targets confidence and natural function.",
  },
  {
    icon: HeartHandshake,
    title: "Compassionate Care",
    text: "A calm, supportive experience for new patients and returning families.",
  },
];

export default function HighlightsPage() {
  return (
    <PageTransition testId="highlights-page">
      <PageHero
        title="Highlights"
        subtitle="What makes Kavlekar Dental a trusted destination for advanced dental care in Hubballi."
        image="https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=2000&q=80"
        testId="highlights-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection testId="highlights-cards-section">
          <div className="grid gap-6 md:grid-cols-3">
            {highlights.map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-[#f2e6c9] bg-white p-6"
                  data-testid={`highlights-card-${item.title
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <Icon className="h-6 w-6 text-[#c5a059]" />
                  <h2
                    className="mt-3 font-[Playfair_Display] text-2xl text-[#1a1a1a]"
                    data-testid={`highlights-card-title-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.title}
                  </h2>
                  <p
                    className="mt-3 font-[Manrope] text-sm text-[#555555]"
                    data-testid={`highlights-card-text-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
